export default class LoginCtrl {

    // @ngInject
    constructor($q, $location, $routeParams, authService,
            responseHandler, nextDispatcher, signupDataStore, cascadedParamExtractor, exampleTypes) {
        this.$q = $q;
        this.$location = $location;
        this.authService = authService;
        this.responseHandler = responseHandler;
        this.verificationStatus = $routeParams.verificationStatus || null;
        this.nextDispatcher = nextDispatcher;
        this.signupDataStore = signupDataStore;
        this.serverError = null;
        let oauthNextParam = cascadedParamExtractor(['next', 'redirect_uri', 'next']);
        if(oauthNextParam) {
            this.oauthNextParam = '?next='+oauthNextParam;
        }
        else {
            this.oauthNextParam = '';
        }
        this.exampleTypes = exampleTypes;
        let nextParam = $location.search().next;
        if (nextParam && nextParam.startsWith('https://')) {
            nextParam = encodeURIComponent(nextParam);
        }
        const nextRedirection = nextParam ? '?next=' + nextParam.replace('%2F%23', '%23') : '';

        this.userLogin = {
            email: undefined,
            password: undefined,
            signupRedirection: this.oauthNextParam !== '' ? this.oauthNextParam : nextRedirection,
            nextRedirection: nextRedirection,
            remember: false,
            exampleType: undefined,
            defaultExampleType: 'webar_example'
        };

        this.slides = [
            {image: 'https://static.blippar.com/accounts-carousel/cell.png',
                title: 'Cell'
            },
            {image: 'https://static.blippar.com/accounts-carousel/elephant.png',
                title: 'Elephant'
            },
            {image: 'https://static.blippar.com/accounts-carousel/solar_system.png',
                title: 'Solar System'
            },
            {image: 'https://static.blippar.com/accounts-carousel/turtle.png',
                title: 'Turtle'
            },
            {image: 'https://static.blippar.com/accounts-carousel/watch.png',
                title: 'Watch'
            }
        ];
        this.loading = false;
    }

    handleError(promise, response={}) {
        if (response.detail === 'error_credentials' ||
            response.detail === 'error_disabled') {
            this.serverError = response.detail;
        } else if (response.detail === 'error_unverified') {
            // Redirect view requires email:
            this.signupDataStore.account = {email: this.userLogin.email};
            this.$location.path('/login/unverified/');
        } else {
            // Let default error handler handle this:
            this.responseHandler(promise, 'logging in');
            return this.$q.reject(response);
        }
    }

    submit() {
        this.loading = true;
        this.serverError = null;
        let promise = this.authService.login(this.userLogin)
            .then(() => this.nextDispatcher())
            .catch((response) => this.handleError(promise, response));
    }
}



// WEBPACK FOOTER //
// ./login/login-ctrl.js